import React from 'react';

const FormLabel = ({ labelFor, name, style }) => (
  <label
    htmlFor={labelFor}
    style={{
      display: 'inline-block',
      fontSize: '.85em',
      fontWeight: 700,
      paddingBottom: '.25em',
      ...style,
    }}
  >
    {name}
  </label>
);

export default FormLabel;
